import { useCallback, useEffect, useState } from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import useAuth from "hooks/use-auth";
import { getUserInfoRequest } from "api/requests";
import useHttp from "hooks/use-http";

import SendOtp from "pages/send-otp";
import Name from "pages/send-otp/addName";
import Home from "pages/home";
import AccessoryProducts from "pages/Accessory";
import ProductDetails from "pages/ProductDetails";
import FurnitureProducts from "pages/Furniture";
import AccessoryAllProducts from "pages/AccessoryAllProducts";
import FurnitureAllProducts from "pages/FurnitureAllProducts";
import CommonQuestion from "pages/common-question";
import News from "pages/news";
import EachNews from "pages/news/eachnews";
import ContactUs from "pages/contactus";
import Complaint from "pages/complaint";
import Rules from "pages/rules";
import Privacy from "pages/privacy";
import AboutUs from "pages/aboutus";
import LoginColleague from "pages/loginColleague";
import ShoppingCart from "pages/ShoppingCart";
import Payment from "pages/payment";
import PaymentStatusFailed from "pages/paymentstatus/failed";
import PaymentStatusSuccessful from "pages/paymentstatus/success";
import Profile from "pages/profile";
import Address from "pages/address";
import AddAddress from "pages/address/add";
import EditAddress from "pages/address/edit";
import Message from "pages/messages";
import EachMessage from "pages/messages/messagebyid";
import Orders from "pages/orders";
import Eachorder from "pages/orders/orderbyid";
import FurnitureAmazing from "pages/AmazingProducts/Furniture";
import AccessoryAmazing from "pages/AmazingProducts/accessory";
import SaerchProduct from "pages/ProductsSearch";
import Ticket from "pages/ticket";
import TicketAdd from "pages/ticket/add";
import EachTicket from "pages/ticket/ticketbyId";
import Branch from "pages/branch";
import PaymentRules from "pages/paymentrules";
import TicketFake from "pages/ticket/fake";
import SiteMap from "pages/SiteMap";

export default function RoutesCM() {
  const AuthCTX = useAuth();
  const { request, loading } = useHttp();
  const [user, setUser] = useState(0);

  const getUserInfo = useCallback(async () => {
    const res = await request({
      url: getUserInfoRequest,
    });
    if (res) {
      setUser(res);
    }
  }, [request]);

  useEffect(() => {
    if (AuthCTX.isLoggedIn) {
      getUserInfo();
    }
  }, []);

  if (AuthCTX.isLoggedIn) {
    return (
      <Routes>
        <Route path="*" element={<Navigate to="/" />} />
        <Route path="/" element={<Home />} />
        <Route path="/name" element={<Name />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/address" element={<Address />} />
        <Route path="/address/add" element={<AddAddress />} />
        <Route path="/address/:addressId" element={<EditAddress />} />
        <Route path="/message" element={<Message />} />
        <Route path="/message/:messageId" element={<EachMessage />} />
        <Route path="/ticket" element={<Ticket />} />
        <Route path="/ticket/new" element={<TicketAdd />} />
        <Route path="/ticket/:messageId" element={<EachTicket />} />
        <Route path="/orders" element={<Orders />} />
        <Route path="/order/:orderId" element={<Eachorder />} />
        <Route path="/shoppingCart" element={<ShoppingCart />} />
        <Route path="/payment" element={<Payment />} />
        <Route
          path="/payment/status/failed"
          element={<PaymentStatusFailed />}
        />
        <Route
          path="/payment/status/successful/:statusId"
          element={<PaymentStatusSuccessful />}
        />
        <Route path="/Furniture/amazing" element={<FurnitureAmazing />} />
        <Route path="/accessory/amazing" element={<AccessoryAmazing />} />
        <Route path="/accessory" element={<AccessoryAllProducts />} />
        <Route path="/accessory/:categoryId" element={<AccessoryProducts />} />
        <Route path="/Furniture" element={<FurnitureAllProducts />} />
        <Route path="/Furniture/:categoryId" element={<FurnitureProducts />} />
        <Route path="/product/:productId" element={<ProductDetails />} />
        <Route path="/article" element={<News />} />
        <Route path="/article/:articleId" element={<EachNews />} />
        <Route path="/contact" element={<ContactUs />} />
        <Route path="/questions" element={<CommonQuestion />} />
        <Route path="/rules" element={<Rules />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/aboutus" element={<AboutUs />} />
        <Route path="/complaint" element={<Complaint />} />
        <Route
          path="/products/search=:searchText"
          element={<SaerchProduct />}
        />
        <Route
          path="/product/:productId/search=:searchText"
          element={<ProductDetails />}
        />
        <Route path="/branch" element={<Branch />} />
        <Route path="/payment/rules" element={<PaymentRules />} />
      </Routes>
    );
  }

  return (
    <Routes>
      <Route path="*" element={<Navigate to="/" />} />
      <Route path="/" element={<Home />} />
      <Route path="/login" element={<SendOtp />} />
      <Route path="/name" element={<Name />} />
      <Route path="/loginColleague" element={<LoginColleague />} />
      <Route path="/Furniture/amazing" element={<FurnitureAmazing />} />
      <Route path="/accessory/amazing" element={<AccessoryAmazing />} />
      <Route path="/accessory" element={<AccessoryAllProducts />} />
      <Route path="/accessory/:categoryId" element={<AccessoryProducts />} />
      <Route path="/Furniture" element={<FurnitureAllProducts />} />
      <Route path="/Furniture/:categoryId" element={<FurnitureProducts />} />
      <Route path="/product/:productId" element={<ProductDetails />} />
      <Route path="/article" element={<News />} />
      <Route path="/article/:articleId" element={<EachNews />} />
      <Route path="/contact" element={<ContactUs />} />
      <Route path="/questions" element={<CommonQuestion />} />
      <Route path="/rules" element={<Rules />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/aboutus" element={<AboutUs />} />
      <Route path="/complaint" element={<Complaint />} />
      <Route path="/products/search=:searchText" element={<SaerchProduct />} />
      <Route
        path="/product/:productId/search=:searchText"
        element={<ProductDetails />}
      />
      <Route path="/branch" element={<Branch />} />
      <Route path="/payment/rules" element={<PaymentRules />} />
      <Route path="/ticket" element={<TicketFake />} />
      <Route path="/sitemap/generate" element={<SiteMap />} />
    </Routes>
  );
}
